module.exports = __webpack_public_path__ + "static/media/hk.856596aa.svg";